import React from "react";

const JQuery_Quiz = () => {
  return (
    <div>
      <h1>JQuery_Quiz</h1>
      <p>Placeholder component for: "JQuery_Quiz"</p>
    </div>
  );
};

export default JQuery_Quiz;
